import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { FaRegEdit } from "react-icons/fa";
import { RiDeleteBin5Line } from "react-icons/ri";
import Contex from '../../Context/CreateContext';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
const Skill = () => {
    const contex = useContext(Contex)
    const  {SkillData, fetchSkillData, updateSkill, showAlert, handleDeleteSkill} = contex
    const [show, setShow] = useState(false);
    const [fetchedData, setFetchedData] = useState({id:"", ename: "",edesc: ""})

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    // 😍   fetch
    useEffect(() => {
        (async () => {
         await  fetchSkillData();
          
    })();
     
    }, [  ])
    

    // 💕🌹 update
    const handleEdit = async(data) =>{
        handleShow();
        setFetchedData({id:data.id, ename:data.name,edesc:data.desc,  })
       
        // setExperienceData(data);
       
      }
             // update  changes in experience data
       const handleUpdate =async()=>{
       
        const res = await   updateSkill({
          id:fetchedData.id,
          name:fetchedData.ename,
           desc:fetchedData.edesc,
          
        });
        const json = await  res.json()
       
        
         if (!res.ok) {
           handleClose()
            showAlert("danger", json.msg)
           
         }else{
           handleClose()
          await  fetchSkillData()
            showAlert("success",json.msg)
         }
       }       
      const onChange = (e) => {
        const {name , value} = e.target
        setFetchedData({...fetchedData, [name]:value})
      }
    const token  = localStorage.getItem("at")

  return (
    <div> 
 <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Experience</Modal.Title>
        </Modal.Header>
       <Modal.Body>
<Form>
<Form.Group className="mb-3" controlId="formBasicEmail">
<Form.Label>Skill Name</Form.Label>
<Form.Control type="text" placeholder="name" name='ename'onChange={onChange}  value ={fetchedData.ename}   />
</Form.Group>

<Form.Group className="mb-3" controlId="formBasicEmail">
<Form.Label>Description</Form.Label>
<Form.Control type="text" placeholder="description" name='edesc'onChange={onChange}  value ={fetchedData.edesc}   />
</Form.Group>
 
</Form>
</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={ async()=> await handleUpdate()}>
           update
          </Button>
        </Modal.Footer>
      </Modal>

 <section className="text-gray-600 body-font" style={{ userSelect: "auto" }}>
  <div className="container px-1 md:px-5 py-4 md:py-24 mx-auto" style={{ userSelect: "auto" }}>
  {/* 💕 Skills */}
    <div
      className="flex flex-wrap w-full mb-2 flex-col items-center text-center"
      style={{ userSelect: "auto" }}
    >
      <h1
        className="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900"
        style={{ userSelect: "auto" }}
      >
      Skills
      </h1>
      <p
        className="lg:w-1/2 w-full leading-relaxed text-gray-500  text-justify md:text-center"
        style={{ userSelect: "auto" }}
      >
       This is my skills, which  i have  applied in my research, publication, educator  journey  and  much more in my life .
      </p>
    </div>
    {token && <>  <div className=" flex justify-center items-center mb-4 mx-auto">
            <button className="  bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-black py-2 px-4  border border-blue-500 hover:border-transparent rounded">
              <Link to="/addSkill" className="no-underline "> add new one</Link>

            </button>
          </div></>}

    <div className="flex flex-wrap -m-4" style={{ userSelect: "auto" }}>

        {SkillData.data && SkillData.data.map((item, i)=>{
            return    <div  key={i} className=" w-full xl:w-1/3 md:w-1/2 md:p-4 p-2" style={{ userSelect: "auto" }}>
            <div
              className="border border-gray-200 p-6 rounded-lg"
              style={{ userSelect: "auto" }}
            >
              {token && <>  <span
                                  className="flex  py-1 px-2 rounded    text-xs font-medium tracking-widest"
                                  style={{ userSelect: "auto" }}
                                >
                                  {/* ❤😊   */}
                                  <FaRegEdit
    
                                    className="mx-2 cursor-pointer"
                                    size={20}
                                    onClick={async() => await handleEdit({ id: item._id, name: item.name, desc: item.desc })}
                                  />
    
                                  <RiDeleteBin5Line
                                    onClick={async() =>  await handleDeleteSkill({ id: item._id })}
                                    className="cursor-pointer"
                                    size={20}
                                  />
                                </span>
                                </>}
              {/* <div
                className="w-10 h-10 inline-flex items-center justify-center rounded-full bg-indigo-100 text-indigo-500 mb-4"
                style={{ userSelect: "auto" }}
              >
                <img src='https://cdn.bitlanders.com/users/galleries/280342/green-economy-2_fa_rszd.jpg'>
                </img>
              </div> */}
              <h2
                className="text-lg text-gray-900 font-medium title-font mb-2"
                style={{ userSelect: "auto" }}
              >
             {item.name}
              </h2>
              <p
                className="leading-relaxed text-base"
                style={{ userSelect: "auto" }}
              >
               {item.desc}
              </p>
            </div>
          </div>
         
        })}
   
      
    </div>
    
  </div>
</section>
    </div>
  )
}

export default Skill